<template>
  <div class="mark-table-cell" @click='changeValue()'>
    <custom-tooltip class="mark-table-cell-tooltip" placement="bottom" popper-class="light-tooltip">
      <div slot='buttonContent'>
        <div class='mark-table-cell__icon' v-if='!markedValue'>
          <span class="material-icons-round">
            change_history
          </span>
        </div>
        <div class='mark-table-cell__icon' v-else>
          <img :src='warningIcon'>
        </div>
      </div>
      <div slot="content">
        <slot name="tooltip">
          <span>{{ $t('mark.leak.as.important') }}</span>
        </slot>
      </div>
    </custom-tooltip>
  </div>
</template>

<script>
import warningIcon from '@/assets/icons/warning_icn@1x.svg';
import CustomTooltip from '@/components/common/CustomTooltip.vue';

export default {
  name: 'MarkTableCell',
  components: {CustomTooltip},
  props: {
    allItems: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async changeValue() {
      await this.$emit('changeMarkedValue', { item: this.item });
    },
  },
  computed: {
    markedValue() {
      return this.allItems[this.item.id - 1]?.mark || false;
    },
    warningIcon() {
      return warningIcon;
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.mark-table-cell {
  z-index: 3;
  .mark-table-cell-tooltip {
    background-color: transparent;
  }
  &__icon {
    .material-icons-round {
      color: var(--brand-primary-hover);
      border-radius: $radius-md;
      font-size: rem(22);
    }
 }
  &:hover {
    cursor: pointer;
  }
}
</style>
